import { useState } from "react"
import { useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import styled from "styled-components"
import { Photo } from "../../../components/media/Photo"
import ImageGallery from "react-image-gallery"

const GalleryWrapper = styled.div`
  height: 250px;
  width: 100%;

  .gallery {
    height: 100%;
  }
`

const MediaScrollableGallery = ({ media }) => {
  const images =
    media.length > 0
      ? media.map((photo) => {
          return {
            original: photo.url,
            thumbnail: photo.url,
            photo,
          }
        })
      : [
          {
            original: "/assets/venues/default.jpg",
            thumbnail: "/assets/venues/default.jpg",
          },
        ]

  return (
    <GalleryWrapper>
      <ImageGallery
        items={images}
        showThumbnails={false}
        useBrowserFullscreen={false}
        showBullets={true}
        additionalClass="gallery"
        showPlayButton={false}
        showFullscreenButton={false}
        renderItem={(item) => {
          return (
            <div style={{ height: 250 }}>
              <img
                src={item.original}
                style={{ objectFit: "cover", width: "100%", height: "100%" }}
              />
            </div>
          )
        }}
      />
    </GalleryWrapper>
  )
}

const VenueSectionPhotosStyled = styled.div<any>`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, 140px);
  gap: 26px 26px;

  @media (max-width: 800px) {
    grid-template-rows: repeat(3, 80px);
  }

  .photo {
    cursor: pointer;
  }

  ${({ count }) =>
    count == 1 &&
    `
    .photo1 {
      grid-column: 1 / span 4; 
      grid-row: 1 / span 3;
    }

  `}

  ${({ count }) =>
    count == 2 &&
    `
    .photo1 {
      grid-column: 1 / span 2; 
      grid-row: 1 / span 3;
    }
    .photo2 {
      grid-column: 3 / span 2; 
      grid-row: 1 / span 3;
    }
  `}

  ${({ count }) =>
    count == 3 &&
    `
  .photo1 {
    grid-column: 1 / span 3; 
    grid-row: 1 / span 3;
  }

  .photo2 {
    grid-column: 4 / span 1; 
    grid-row: 1 / span 2;
  }
  
  .photo3 {
    grid-column: 4 / span 1; 
    grid-row: 3 / span 1;
  }

`}

  ${({ count }) =>
    count >= 4 &&
    `
    .photo1 {
      grid-column: 1 / span 3; 
      grid-row: 1 / span 3;
    }
    .photo2 {
      grid-column: 4 / 4; 
      grid-row: 1 / span 1;
    }
    .photo3 {
      grid-column: 4 / 4; 
      grid-row: 2 / span 1;
    }
    .photo4 {
      grid-column: 4 / 4; 
      grid-row: 3/ span 1;
    }
  `}
`

function WebGallery({ venue }) {
  const [main, setMain] = useState(0)
  const mainPhoto = venue.media.slice(main, main + 1)
  const remainingsPhoto = venue.media
    .slice(0, main)
    .concat(venue.media.slice(main + 1))
  const finalGallery = mainPhoto.concat(remainingsPhoto)
  var photosCount = Math.min(4, venue.media.length)
  // Code to use default photo if there is none in the venue
  if (finalGallery.length == 0) {
    finalGallery.push("/assets/venues/default.jpg")
    photosCount = 1
  }
  return (
    <VenueSectionPhotosStyled
      className="rounded-xl overflow-hidden"
      count={photosCount}
    >
      {finalGallery.slice(0, photosCount).map((photo, index) => {
        return (
          <div
            className={`photo photo${index + 1}`}
            key={index}
            onClick={() =>
              index !== 0 && setMain(index <= main ? index - 1 : index)
            }
          >
            {/* <PhotoWrapper> */}
            <Photo media={photo} imgWidth={1128} />
            {/* </PhotoWrapper> */}
          </div>
        )
      })}
    </VenueSectionPhotosStyled>
  )
}

export const VenueSectionPhotos = ({ venue }) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"))

  return venue && venue.media ? (
    isDesktop ? (
      <WebGallery venue={venue} />
    ) : (
      <MediaScrollableGallery media={venue.media} />
    )
  ) : null
}
